import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from '@/components/ui/sonner';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';

import Home from '@/pages/Home';
import About from '@/pages/About';
import PreInscription from '@/pages/PreInscription';
import Filieres from '@/pages/Filieres';
import VieEtudiantines from '@/pages/VieEtudiantines';
import Galerie from '@/pages/Galerie';
import Contact from '@/pages/Contact';
import Equipe from '@/pages/Equipe';
import Partenaires from '@/pages/Partenaires';
import AdminPreinscriptions from '@/pages/AdminPreinscriptions';
import AdminStatistics from '@/pages/AdminStatistics';
import AdminLogin from '@/pages/AdminLogin';

// Import all filiere pages
import EconomieGestion from '@/pages/filieres/EconomieGestion';
import Droit from '@/pages/filieres/Droit';
import MarketingManagement from '@/pages/filieres/MarketingManagement';
import Informatique from '@/pages/filieres/Informatique';
import GRH from '@/pages/filieres/GRH';
import Mathematiques from '@/pages/filieres/Mathematiques';
import Anglais from '@/pages/filieres/Anglais';
import LettresModernes from '@/pages/filieres/LettresModernes';
import Histoire from '@/pages/filieres/Histoire';
import Geographie from '@/pages/filieres/Geographie';
import SciencesPhysiques from '@/pages/filieres/SciencesPhysiques';
import FiliereDetail from '@/pages/FiliereDetail';

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/qui-sommes-nous" element={<About />} />
          <Route path="/preinscription" element={<PreInscription />} />
          <Route path="/filieres" element={<Filieres />} />
          
          {/* Individual Filiere Pages - Legacy routes */}
          <Route path="/filieres/economie-gestion" element={<EconomieGestion />} />
          <Route path="/filieres/droit" element={<Droit />} />
          <Route path="/filieres/marketing-management" element={<MarketingManagement />} />
          <Route path="/filieres/informatique" element={<Informatique />} />
          <Route path="/filieres/grh" element={<GRH />} />
          <Route path="/filieres/mathematiques" element={<Mathematiques />} />
          <Route path="/filieres/anglais" element={<Anglais />} />
          <Route path="/filieres/lettres-modernes" element={<LettresModernes />} />
          <Route path="/filieres/histoire" element={<Histoire />} />
          <Route path="/filieres/geographie" element={<Geographie />} />
          <Route path="/filieres/sciences-physiques" element={<SciencesPhysiques />} />
          
          {/* Dynamic Filiere Route - New structure */}
          <Route path="/filieres/:slug" element={<FiliereDetail />} />
          
          <Route path="/vie-estudiantines" element={<VieEtudiantines />} />
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/equipe" element={<Equipe />} />
          <Route path="/partenaires" element={<Partenaires />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/preinscriptions" element={<AdminPreinscriptions />} />
          <Route path="/admin/statistics" element={<AdminStatistics />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;